// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"pageLayout_pageLayout__3LeDH"};